export const stepUp = (value: number, step: number, max: number) => {
	const rounded = Math.ceil(value / step) * step;
	return Math.min(max, rounded > value ? rounded : value + step);
};
